import React from 'react';
import { IntakeDetail } from '@/components/intakes/IntakeDetail';

export function IntakeDetailPage() {
  return (
    <div className="container mx-auto px-6 py-8">
      <IntakeDetail />
    </div>
  );
}